//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  VIcon,
  VBtn,
} from "vuetify/lib";

import colors from '@/styles/colors.scss';

export default {
  name: "CancelButton",
  components: {
    VIcon,
    VBtn,
  },
  data: function () {
    return {
      colors,
    };
  },
};
